import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../../@types/RootState';

export type RulesPageFiltersQueryState = Record<string, string>;

const initialState: RulesPageFiltersQueryState = {};

const slice = createSlice({
  name: 'ipa.strategy.rules.filters.query',
  initialState,
  reducers: {
    RESET_RULES_PAGE_FILTERS_QUERY: () => initialState,
    SET_RULES_PAGE_FILTERS_QUERY_BY_KEY: (state, action: PayloadAction<{ key: keyof RulesPageFiltersQueryState; query: string }>) => {
      return { ...state, [action.payload.key]: action.payload.query };
    },
  },
});

export const selectorRulesPageFiltersQuery = (state: RootState) => state.ipa.strategy.rules.filters.query;

export const { RESET_RULES_PAGE_FILTERS_QUERY, SET_RULES_PAGE_FILTERS_QUERY_BY_KEY } = slice.actions;

export default slice.reducer;
